import {
	AcademicCapIcon,
	AdjustmentsHorizontalIcon,
	AdjustmentsVerticalIcon,
	ArchiveBoxArrowDownIcon,
	ArchiveBoxIcon,
	ArchiveBoxXMarkIcon,
	ArrowDownCircleIcon,
	ArrowDownIcon,
	ArrowDownLeftIcon,
	ArrowDownOnSquareIcon,
	ArrowDownOnSquareStackIcon,
	ArrowDownRightIcon,
	ArrowDownTrayIcon,
	ArrowLeftCircleIcon,
	ArrowLeftEndOnRectangleIcon,
	ArrowLeftIcon,
	ArrowLeftOnRectangleIcon,
	ArrowLeftStartOnRectangleIcon,
	ArrowLongDownIcon,
	ArrowLongLeftIcon,
	ArrowLongRightIcon,
	ArrowLongUpIcon,
	ArrowPathIcon,
	ArrowPathRoundedSquareIcon,
	ArrowRightCircleIcon,
	ArrowRightEndOnRectangleIcon,
	ArrowRightIcon,
	ArrowRightOnRectangleIcon,
	ArrowRightStartOnRectangleIcon,
	ArrowSmallDownIcon,
	ArrowSmallLeftIcon,
	ArrowSmallRightIcon,
	ArrowSmallUpIcon,
	ArrowTopRightOnSquareIcon,
	ArrowTrendingDownIcon,
	ArrowTrendingUpIcon,
	ArrowTurnDownLeftIcon,
	ArrowTurnDownRightIcon,
	ArrowTurnLeftDownIcon,
	ArrowTurnLeftUpIcon,
	ArrowTurnRightDownIcon,
	ArrowTurnRightUpIcon,
	ArrowTurnUpLeftIcon,
	ArrowTurnUpRightIcon,
	ArrowUpCircleIcon,
	ArrowUpIcon,
	ArrowUpLeftIcon,
	ArrowUpOnSquareIcon,
	ArrowUpOnSquareStackIcon,
	ArrowUpRightIcon,
	ArrowUpTrayIcon,
	ArrowUturnDownIcon,
	ArrowUturnLeftIcon,
	ArrowUturnRightIcon,
	ArrowUturnUpIcon,
	ArrowsPointingInIcon,
	ArrowsPointingOutIcon,
	ArrowsRightLeftIcon,
	ArrowsUpDownIcon,
	AtSymbolIcon,
	BackspaceIcon,
	BackwardIcon,
	BanknotesIcon,
	Bars2Icon,
	Bars3BottomLeftIcon,
	Bars3BottomRightIcon,
	Bars3CenterLeftIcon,
	Bars3Icon,
	Bars4Icon,
	BarsArrowDownIcon,
	BarsArrowUpIcon,
	Battery0Icon,
	Battery100Icon,
	Battery50Icon,
	BeakerIcon,
	BellAlertIcon,
	BellIcon,
	BellSlashIcon,
	BellSnoozeIcon,
	BoldIcon,
	BoltIcon,
	BoltSlashIcon,
	BookOpenIcon,
	BookmarkIcon,
	BookmarkSlashIcon,
	BookmarkSquareIcon,
	BriefcaseIcon,
	BugAntIcon,
	BuildingLibraryIcon,
	BuildingOffice2Icon,
	BuildingOfficeIcon,
	BuildingStorefrontIcon,
	CakeIcon,
	CalculatorIcon,
	CalendarDateRangeIcon,
	CalendarDaysIcon,
	CalendarIcon,
	CameraIcon,
	ChartBarIcon,
	ChartBarSquareIcon,
	ChartPieIcon,
	ChatBubbleBottomCenterIcon,
	ChatBubbleBottomCenterTextIcon,
	ChatBubbleLeftEllipsisIcon,
	ChatBubbleLeftIcon,
	ChatBubbleLeftRightIcon,
	ChatBubbleOvalLeftEllipsisIcon,
	ChatBubbleOvalLeftIcon,
	CheckBadgeIcon,
	CheckCircleIcon,
	CheckIcon,
	ChevronDoubleDownIcon,
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronDoubleUpIcon,
	ChevronDownIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ChevronUpDownIcon,
	ChevronUpIcon,
	CircleStackIcon,
	ClipboardDocumentCheckIcon,
	ClipboardDocumentIcon,
	ClipboardDocumentListIcon,
	ClipboardIcon,
	ClockIcon,
	CloudArrowDownIcon,
	CloudArrowUpIcon,
	CloudIcon,
	CodeBracketIcon,
	CodeBracketSquareIcon,
	Cog6ToothIcon,
	Cog8ToothIcon,
	CogIcon,
	CommandLineIcon,
	ComputerDesktopIcon,
	CpuChipIcon,
	CreditCardIcon,
	CubeIcon,
	CubeTransparentIcon,
	CurrencyBangladeshiIcon,
	CurrencyDollarIcon,
	CurrencyEuroIcon,
	CurrencyPoundIcon,
	CurrencyRupeeIcon,
	CurrencyYenIcon,
	CursorArrowRaysIcon,
	CursorArrowRippleIcon,
	DevicePhoneMobileIcon,
	DeviceTabletIcon,
	DivideIcon,
	DocumentArrowDownIcon,
	DocumentArrowUpIcon,
	DocumentChartBarIcon,
	DocumentCheckIcon,
	DocumentCurrencyBangladeshiIcon,
	DocumentCurrencyDollarIcon,
	DocumentCurrencyEuroIcon,
	DocumentCurrencyPoundIcon,
	DocumentCurrencyRupeeIcon,
	DocumentCurrencyYenIcon,
	DocumentDuplicateIcon,
	DocumentIcon,
	DocumentMagnifyingGlassIcon,
	DocumentMinusIcon,
	DocumentPlusIcon,
	DocumentTextIcon,
	EllipsisHorizontalCircleIcon,
	EllipsisHorizontalIcon,
	EllipsisVerticalIcon,
	EnvelopeIcon,
	EnvelopeOpenIcon,
	EqualsIcon,
	ExclamationCircleIcon,
	ExclamationTriangleIcon,
	EyeDropperIcon,
	EyeIcon,
	EyeSlashIcon,
	FaceFrownIcon,
	FaceSmileIcon,
	FilmIcon,
	FingerPrintIcon,
	FireIcon,
	FlagIcon,
	FolderArrowDownIcon,
	FolderIcon,
	FolderMinusIcon,
	FolderOpenIcon,
	FolderPlusIcon,
	ForwardIcon,
	FunnelIcon,
	GifIcon,
	GiftIcon,
	GiftTopIcon,
	GlobeAltIcon,
	GlobeAmericasIcon,
	GlobeAsiaAustraliaIcon,
	GlobeEuropeAfricaIcon,
	H1Icon,
	H2Icon,
	H3Icon,
	HandRaisedIcon,
	HandThumbDownIcon,
	HandThumbUpIcon,
	HashtagIcon,
	HeartIcon,
	HomeIcon,
	HomeModernIcon,
	IdentificationIcon,
	InboxArrowDownIcon,
	InboxIcon,
	InboxStackIcon,
	InformationCircleIcon,
	ItalicIcon,
	KeyIcon,
	LanguageIcon,
	LifebuoyIcon,
	LightBulbIcon,
	LinkIcon,
	LinkSlashIcon,
	ListBulletIcon,
	LockClosedIcon,
	LockOpenIcon,
	MagnifyingGlassCircleIcon,
	MagnifyingGlassIcon,
	MagnifyingGlassMinusIcon,
	MagnifyingGlassPlusIcon,
	MapIcon,
	MapPinIcon,
	MegaphoneIcon,
	MicrophoneIcon,
	MinusCircleIcon,
	MinusIcon,
	MinusSmallIcon,
	MoonIcon,
	MusicalNoteIcon,
	NewspaperIcon,
	NoSymbolIcon,
	NumberedListIcon,
	PaintBrushIcon,
	PaperAirplaneIcon,
	PaperClipIcon,
	PauseCircleIcon,
	PauseIcon,
	PencilIcon,
	PencilSquareIcon,
	PercentBadgeIcon,
	PhoneArrowDownLeftIcon,
	PhoneArrowUpRightIcon,
	PhoneIcon,
	PhoneXMarkIcon,
	PhotoIcon,
	PlayCircleIcon,
	PlayIcon,
	PlayPauseIcon,
	PlusCircleIcon,
	PlusIcon,
	PlusSmallIcon,
	PowerIcon,
	PresentationChartBarIcon,
	PresentationChartLineIcon,
	PrinterIcon,
	PuzzlePieceIcon,
	QrCodeIcon,
	QuestionMarkCircleIcon,
	QueueListIcon,
	RadioIcon,
	ReceiptPercentIcon,
	ReceiptRefundIcon,
	RectangleGroupIcon,
	RectangleStackIcon,
	RocketLaunchIcon,
	RssIcon,
	ScaleIcon,
	ScissorsIcon,
	ServerIcon,
	ServerStackIcon,
	ShareIcon,
	ShieldCheckIcon,
	ShieldExclamationIcon,
	ShoppingBagIcon,
	ShoppingCartIcon,
	SignalIcon,
	SignalSlashIcon,
	SlashIcon,
	SparklesIcon,
	SpeakerWaveIcon,
	SpeakerXMarkIcon,
	Square2StackIcon,
	Square3Stack3DIcon,
	Squares2X2Icon,
	SquaresPlusIcon,
	StarIcon,
	StopCircleIcon,
	StopIcon,
	StrikethroughIcon,
	SunIcon,
	SwatchIcon,
	TableCellsIcon,
	TagIcon,
	TicketIcon,
	TrashIcon,
	TrophyIcon,
	TruckIcon,
	TvIcon,
	UnderlineIcon,
	UserCircleIcon,
	UserGroupIcon,
	UserIcon,
	UserMinusIcon,
	UserPlusIcon,
	UsersIcon,
	VariableIcon,
	VideoCameraIcon,
	VideoCameraSlashIcon,
	ViewColumnsIcon,
	ViewfinderCircleIcon,
	WalletIcon,
	WifiIcon,
	WindowIcon,
	WrenchIcon,
	WrenchScrewdriverIcon,
	XCircleIcon,
	XMarkIcon,
} from "@heroicons/react/24/outline";
const iconsListOutline = [
	{
		name: "academic-cap-icon",
		icon: AcademicCapIcon,
	},
	{
		name: "adjustments-horizontal-icon",
		icon: AdjustmentsHorizontalIcon,
	},
	{
		name: "adjustments-vertical-icon",
		icon: AdjustmentsVerticalIcon,
	},
	{
		name: "archive-box-arrow-down-icon",
		icon: ArchiveBoxArrowDownIcon,
	},
	{
		name: "archive-box-icon",
		icon: ArchiveBoxIcon,
	},
	{
		name: "archive-box-xmark-icon",
		icon: ArchiveBoxXMarkIcon,
	},
	{
		name: "arrow-down-circle-icon",
		icon: ArrowDownCircleIcon,
	},
	{
		name: "arrow-down-icon",
		icon: ArrowDownIcon,
	},
	{
		name: "arrow-down-left-icon",
		icon: ArrowDownLeftIcon,
	},
	{
		name: "arrow-down-on-square-icon",
		icon: ArrowDownOnSquareIcon,
	},
	{
		name: "arrow-down-on-square-stack-icon",
		icon: ArrowDownOnSquareStackIcon,
	},
	{
		name: "arrow-down-right-icon",
		icon: ArrowDownRightIcon,
	},
	{
		name: "arrow-down-tray-icon",
		icon: ArrowDownTrayIcon,
	},
	{
		name: "arrow-left-circle-icon",
		icon: ArrowLeftCircleIcon,
	},
	{
		name: "arrow-left-end-on-rectangle-icon",
		icon: ArrowLeftEndOnRectangleIcon,
	},
	{
		name: "arrow-left-icon",
		icon: ArrowLeftIcon,
	},
	{
		name: "arrow-left-on-rectangle-icon",
		icon: ArrowLeftOnRectangleIcon,
	},
	{
		name: "arrow-left-start-on-rectangle-icon",
		icon: ArrowLeftStartOnRectangleIcon,
	},
	{
		name: "arrow-long-down-icon",
		icon: ArrowLongDownIcon,
	},
	{
		name: "arrow-long-left-icon",
		icon: ArrowLongLeftIcon,
	},
	{
		name: "arrow-long-right-icon",
		icon: ArrowLongRightIcon,
	},
	{
		name: "arrow-long-up-icon",
		icon: ArrowLongUpIcon,
	},
	{
		name: "arrow-path-icon",
		icon: ArrowPathIcon,
	},
	{
		name: "arrow-path-rounded-square-icon",
		icon: ArrowPathRoundedSquareIcon,
	},
	{
		name: "arrow-right-circle-icon",
		icon: ArrowRightCircleIcon,
	},
	{
		name: "arrow-right-end-on-rectangle-icon",
		icon: ArrowRightEndOnRectangleIcon,
	},
	{
		name: "arrow-right-icon",
		icon: ArrowRightIcon,
	},
	{
		name: "arrow-right-on-rectangle-icon",
		icon: ArrowRightOnRectangleIcon,
	},
	{
		name: "arrow-right-start-on-rectangle-icon",
		icon: ArrowRightStartOnRectangleIcon,
	},
	{
		name: "arrow-small-down-icon",
		icon: ArrowSmallDownIcon,
	},
	{
		name: "arrow-small-left-icon",
		icon: ArrowSmallLeftIcon,
	},
	{
		name: "arrow-small-right-icon",
		icon: ArrowSmallRightIcon,
	},
	{
		name: "arrow-small-up-icon",
		icon: ArrowSmallUpIcon,
	},
	{
		name: "arrow-top-right-on-square-icon",
		icon: ArrowTopRightOnSquareIcon,
	},
	{
		name: "arrow-trending-down-icon",
		icon: ArrowTrendingDownIcon,
	},
	{
		name: "arrow-trending-up-icon",
		icon: ArrowTrendingUpIcon,
	},
	{
		name: "arrow-turn-down-left-icon",
		icon: ArrowTurnDownLeftIcon,
	},
	{
		name: "arrow-turn-down-right-icon",
		icon: ArrowTurnDownRightIcon,
	},
	{
		name: "arrow-turn-left-down-icon",
		icon: ArrowTurnLeftDownIcon,
	},
	{
		name: "arrow-turn-left-up-icon",
		icon: ArrowTurnLeftUpIcon,
	},
	{
		name: "arrow-turn-right-down-icon",
		icon: ArrowTurnRightDownIcon,
	},
	{
		name: "arrow-turn-right-up-icon",
		icon: ArrowTurnRightUpIcon,
	},
	{
		name: "arrow-turn-up-left-icon",
		icon: ArrowTurnUpLeftIcon,
	},
	{
		name: "arrow-turn-up-right-icon",
		icon: ArrowTurnUpRightIcon,
	},
	{
		name: "arrow-up-circle-icon",
		icon: ArrowUpCircleIcon,
	},
	{
		name: "arrow-up-icon",
		icon: ArrowUpIcon,
	},
	{
		name: "arrow-up-left-icon",
		icon: ArrowUpLeftIcon,
	},
	{
		name: "arrow-up-on-square-icon",
		icon: ArrowUpOnSquareIcon,
	},
	{
		name: "arrow-up-on-square-stack-icon",
		icon: ArrowUpOnSquareStackIcon,
	},
	{
		name: "arrow-up-right-icon",
		icon: ArrowUpRightIcon,
	},
	{
		name: "arrow-up-tray-icon",
		icon: ArrowUpTrayIcon,
	},
	{
		name: "arrow-uturn-down-icon",
		icon: ArrowUturnDownIcon,
	},
	{
		name: "arrow-uturn-left-icon",
		icon: ArrowUturnLeftIcon,
	},
	{
		name: "arrow-uturn-right-icon",
		icon: ArrowUturnRightIcon,
	},
	{
		name: "arrow-uturn-up-icon",
		icon: ArrowUturnUpIcon,
	},
	{
		name: "arrows-pointing-in-icon",
		icon: ArrowsPointingInIcon,
	},
	{
		name: "arrows-pointing-out-icon",
		icon: ArrowsPointingOutIcon,
	},
	{
		name: "arrows-right-left-icon",
		icon: ArrowsRightLeftIcon,
	},
	{
		name: "arrows-up-down-icon",
		icon: ArrowsUpDownIcon,
	},
	{
		name: "at-symbol-icon",
		icon: AtSymbolIcon,
	},
	{
		name: "backspace-icon",
		icon: BackspaceIcon,
	},
	{
		name: "backward-icon",
		icon: BackwardIcon,
	},
	{
		name: "banknotes-icon",
		icon: BanknotesIcon,
	},
	{
		name: "bars-2-icon",
		icon: Bars2Icon,
	},
	{
		name: "bars-3-bottom-left-icon",
		icon: Bars3BottomLeftIcon,
	},
	{
		name: "bars-3-bottom-right-icon",
		icon: Bars3BottomRightIcon,
	},
	{
		name: "bars-3-center-left-icon",
		icon: Bars3CenterLeftIcon,
	},
	{
		name: "bars-3-icon",
		icon: Bars3Icon,
	},
	{
		name: "bars-4-icon",
		icon: Bars4Icon,
	},
	{
		name: "bars-arrow-down-icon",
		icon: BarsArrowDownIcon,
	},
	{
		name: "bars-arrow-up-icon",
		icon: BarsArrowUpIcon,
	},
	{
		name: "battery-0-icon",
		icon: Battery0Icon,
	},
	{
		name: "battery-100-icon",
		icon: Battery100Icon,
	},
	{
		name: "battery-50-icon",
		icon: Battery50Icon,
	},
	{
		name: "beaker-icon",
		icon: BeakerIcon,
	},
	{
		name: "bell-alert-icon",
		icon: BellAlertIcon,
	},
	{
		name: "bell-icon",
		icon: BellIcon,
	},
	{
		name: "bell-slash-icon",
		icon: BellSlashIcon,
	},
	{
		name: "bell-snooze-icon",
		icon: BellSnoozeIcon,
	},
	{
		name: "bold-icon",
		icon: BoldIcon,
	},
	{
		name: "bolt-icon",
		icon: BoltIcon,
	},
	{
		name: "bolt-slash-icon",
		icon: BoltSlashIcon,
	},
	{
		name: "book-open-icon",
		icon: BookOpenIcon,
	},
	{
		name: "bookmark-icon",
		icon: BookmarkIcon,
	},
	{
		name: "bookmark-slash-icon",
		icon: BookmarkSlashIcon,
	},
	{
		name: "bookmark-square-icon",
		icon: BookmarkSquareIcon,
	},
	{
		name: "briefcase-icon",
		icon: BriefcaseIcon,
	},
	{
		name: "bug-ant-icon",
		icon: BugAntIcon,
	},
	{
		name: "building-library-icon",
		icon: BuildingLibraryIcon,
	},
	{
		name: "building-office-2-icon",
		icon: BuildingOffice2Icon,
	},
	{
		name: "building-office-icon",
		icon: BuildingOfficeIcon,
	},
	{
		name: "building-storefront-icon",
		icon: BuildingStorefrontIcon,
	},
	{
		name: "cake-icon",
		icon: CakeIcon,
	},
	{
		name: "calculator-icon",
		icon: CalculatorIcon,
	},
	{
		name: "calendar-date-range-icon",
		icon: CalendarDateRangeIcon,
	},
	{
		name: "calendar-days-icon",
		icon: CalendarDaysIcon,
	},
	{
		name: "calendar-icon",
		icon: CalendarIcon,
	},
	{
		name: "camera-icon",
		icon: CameraIcon,
	},
	{
		name: "chart-bar-icon",
		icon: ChartBarIcon,
	},
	{
		name: "chart-bar-square-icon",
		icon: ChartBarSquareIcon,
	},
	{
		name: "chart-pie-icon",
		icon: ChartPieIcon,
	},
	{
		name: "chat-bubble-bottom-center-icon",
		icon: ChatBubbleBottomCenterIcon,
	},
	{
		name: "chat-bubble-bottom-center-text-icon",
		icon: ChatBubbleBottomCenterTextIcon,
	},
	{
		name: "chat-bubble-left-ellipsis-icon",
		icon: ChatBubbleLeftEllipsisIcon,
	},
	{
		name: "chat-bubble-left-icon",
		icon: ChatBubbleLeftIcon,
	},
	{
		name: "chat-bubble-left-right-icon",
		icon: ChatBubbleLeftRightIcon,
	},
	{
		name: "chat-bubble-oval-left-ellipsis-icon",
		icon: ChatBubbleOvalLeftEllipsisIcon,
	},
	{
		name: "chat-bubble-oval-left-icon",
		icon: ChatBubbleOvalLeftIcon,
	},
	{
		name: "check-badge-icon",
		icon: CheckBadgeIcon,
	},
	{
		name: "check-circle-icon",
		icon: CheckCircleIcon,
	},
	{
		name: "check-icon",
		icon: CheckIcon,
	},
	{
		name: "chevron-double-down-icon",
		icon: ChevronDoubleDownIcon,
	},
	{
		name: "chevron-double-left-icon",
		icon: ChevronDoubleLeftIcon,
	},
	{
		name: "chevron-double-right-icon",
		icon: ChevronDoubleRightIcon,
	},
	{
		name: "chevron-double-up-icon",
		icon: ChevronDoubleUpIcon,
	},
	{
		name: "chevron-down-icon",
		icon: ChevronDownIcon,
	},
	{
		name: "chevron-left-icon",
		icon: ChevronLeftIcon,
	},
	{
		name: "chevron-right-icon",
		icon: ChevronRightIcon,
	},
	{
		name: "chevron-up-down-icon",
		icon: ChevronUpDownIcon,
	},
	{
		name: "chevron-up-icon",
		icon: ChevronUpIcon,
	},
	{
		name: "circle-stack-icon",
		icon: CircleStackIcon,
	},
	{
		name: "clipboard-document-check-icon",
		icon: ClipboardDocumentCheckIcon,
	},
	{
		name: "clipboard-document-icon",
		icon: ClipboardDocumentIcon,
	},
	{
		name: "clipboard-document-list-icon",
		icon: ClipboardDocumentListIcon,
	},
	{
		name: "clipboard-icon",
		icon: ClipboardIcon,
	},
	{
		name: "clock-icon",
		icon: ClockIcon,
	},
	{
		name: "cloud-arrow-down-icon",
		icon: CloudArrowDownIcon,
	},
	{
		name: "cloud-arrow-up-icon",
		icon: CloudArrowUpIcon,
	},
	{
		name: "cloud-icon",
		icon: CloudIcon,
	},
	{
		name: "code-bracket-icon",
		icon: CodeBracketIcon,
	},
	{
		name: "code-bracket-square-icon",
		icon: CodeBracketSquareIcon,
	},
	{
		name: "cog6tooth-icon",
		icon: Cog6ToothIcon,
	},
	{
		name: "cog8tooth-icon",
		icon: Cog8ToothIcon,
	},
	{
		name: "cog-icon",
		icon: CogIcon,
	},
	{
		name: "command-line-icon",
		icon: CommandLineIcon,
	},
	{
		name: "computer-desktop-icon",
		icon: ComputerDesktopIcon,
	},
	{
		name: "cpu-chip-icon",
		icon: CpuChipIcon,
	},
	{
		name: "credit-card-icon",
		icon: CreditCardIcon,
	},
	{
		name: "cube-icon",
		icon: CubeIcon,
	},
	{
		name: "cube-transparent-icon",
		icon: CubeTransparentIcon,
	},
	{
		name: "currency-bangladeshi-icon",
		icon: CurrencyBangladeshiIcon,
	},
	{
		name: "currency-dollar-icon",
		icon: CurrencyDollarIcon,
	},
	{
		name: "currency-euro-icon",
		icon: CurrencyEuroIcon,
	},
	{
		name: "currency-pound-icon",
		icon: CurrencyPoundIcon,
	},
	{
		name: "currency-rupee-icon",
		icon: CurrencyRupeeIcon,
	},
	{
		name: "currency-yen-icon",
		icon: CurrencyYenIcon,
	},
	{
		name: "cursor-arrow-rays-icon",
		icon: CursorArrowRaysIcon,
	},
	{
		name: "cursor-arrow-ripple-icon",
		icon: CursorArrowRippleIcon,
	},
	{
		name: "device-phone-mobile-icon",
		icon: DevicePhoneMobileIcon,
	},
	{
		name: "device-tablet-icon",
		icon: DeviceTabletIcon,
	},
	{
		name: "divide-icon",
		icon: DivideIcon,
	},
	{
		name: "document-arrow-down-icon",
		icon: DocumentArrowDownIcon,
	},
	{
		name: "document-arrow-up-icon",
		icon: DocumentArrowUpIcon,
	},
	{
		name: "document-chart-bar-icon",
		icon: DocumentChartBarIcon,
	},
	{
		name: "document-check-icon",
		icon: DocumentCheckIcon,
	},
	{
		name: "document-currency-bangladeshi-icon",
		icon: DocumentCurrencyBangladeshiIcon,
	},
	{
		name: "document-currency-dollar-icon",
		icon: DocumentCurrencyDollarIcon,
	},
	{
		name: "document-currency-euro-icon",
		icon: DocumentCurrencyEuroIcon,
	},
	{
		name: "document-currency-pound-icon",
		icon: DocumentCurrencyPoundIcon,
	},
	{
		name: "document-currency-rupee-icon",
		icon: DocumentCurrencyRupeeIcon,
	},
	{
		name: "document-currency-yen-icon",
		icon: DocumentCurrencyYenIcon,
	},
	{
		name: "document-duplicate-icon",
		icon: DocumentDuplicateIcon,
	},
	{
		name: "document-icon",
		icon: DocumentIcon,
	},
	{
		name: "document-magnifying-glass-icon",
		icon: DocumentMagnifyingGlassIcon,
	},
	{
		name: "document-minus-icon",
		icon: DocumentMinusIcon,
	},
	{
		name: "document-plus-icon",
		icon: DocumentPlusIcon,
	},
	{
		name: "document-text-icon",
		icon: DocumentTextIcon,
	},
	{
		name: "ellipsis-horizontal-circle-icon",
		icon: EllipsisHorizontalCircleIcon,
	},
	{
		name: "ellipsis-horizontal-icon",
		icon: EllipsisHorizontalIcon,
	},
	{
		name: "ellipsis-vertical-icon",
		icon: EllipsisVerticalIcon,
	},
	{
		name: "envelope-icon",
		icon: EnvelopeIcon,
	},
	{
		name: "envelope-open-icon",
		icon: EnvelopeOpenIcon,
	},
	{
		name: "equals-icon",
		icon: EqualsIcon,
	},
	{
		name: "exclamation-circle-icon",
		icon: ExclamationCircleIcon,
	},
	{
		name: "exclamation-triangle-icon",
		icon: ExclamationTriangleIcon,
	},
	{
		name: "eye-dropper-icon",
		icon: EyeDropperIcon,
	},
	{
		name: "eye-icon",
		icon: EyeIcon,
	},
	{
		name: "eye-slash-icon",
		icon: EyeSlashIcon,
	},
	{
		name: "face-frown-icon",
		icon: FaceFrownIcon,
	},
	{
		name: "face-smile-icon",
		icon: FaceSmileIcon,
	},
	{
		name: "film-icon",
		icon: FilmIcon,
	},
	{
		name: "finger-print-icon",
		icon: FingerPrintIcon,
	},
	{
		name: "fire-icon",
		icon: FireIcon,
	},
	{
		name: "flag-icon",
		icon: FlagIcon,
	},
	{
		name: "folder-arrow-down-icon",
		icon: FolderArrowDownIcon,
	},
	{
		name: "folder-icon",
		icon: FolderIcon,
	},
	{
		name: "folder-minus-icon",
		icon: FolderMinusIcon,
	},
	{
		name: "folder-open-icon",
		icon: FolderOpenIcon,
	},
	{
		name: "folder-plus-icon",
		icon: FolderPlusIcon,
	},
	{
		name: "forward-icon",
		icon: ForwardIcon,
	},
	{
		name: "funnel-icon",
		icon: FunnelIcon,
	},
	{
		name: "gif-icon",
		icon: GifIcon,
	},
	{
		name: "gift-icon",
		icon: GiftIcon,
	},
	{
		name: "gift-top-icon",
		icon: GiftTopIcon,
	},
	{
		name: "globe-alt-icon",
		icon: GlobeAltIcon,
	},
	{
		name: "globe-americas-icon",
		icon: GlobeAmericasIcon,
	},
	{
		name: "globe-asia-australia-icon",
		icon: GlobeAsiaAustraliaIcon,
	},
	{
		name: "globe-europe-africa-icon",
		icon: GlobeEuropeAfricaIcon,
	},
	{
		name: "h1-icon",
		icon: H1Icon,
	},
	{
		name: "h2-icon",
		icon: H2Icon,
	},
	{
		name: "h3-icon",
		icon: H3Icon,
	},
	{
		name: "hand-raised-icon",
		icon: HandRaisedIcon,
	},
	{
		name: "hand-thumb-down-icon",
		icon: HandThumbDownIcon,
	},
	{
		name: "hand-thumb-up-icon",
		icon: HandThumbUpIcon,
	},
	{
		name: "hashtag-icon",
		icon: HashtagIcon,
	},
	{
		name: "heart-icon",
		icon: HeartIcon,
	},
	{
		name: "home-icon",
		icon: HomeIcon,
	},
	{
		name: "home-modern-icon",
		icon: HomeModernIcon,
	},
	{
		name: "identification-icon",
		icon: IdentificationIcon,
	},
	{
		name: "inbox-arrow-down-icon",
		icon: InboxArrowDownIcon,
	},
	{
		name: "inbox-icon",
		icon: InboxIcon,
	},
	{
		name: "inbox-stack-icon",
		icon: InboxStackIcon,
	},
	{
		name: "information-circle-icon",
		icon: InformationCircleIcon,
	},
	{
		name: "italic-icon",
		icon: ItalicIcon,
	},
	{
		name: "key-icon",
		icon: KeyIcon,
	},
	{
		name: "language-icon",
		icon: LanguageIcon,
	},
	{
		name: "lifebuoy-icon",
		icon: LifebuoyIcon,
	},
	{
		name: "light-bulb-icon",
		icon: LightBulbIcon,
	},
	{
		name: "link-icon",
		icon: LinkIcon,
	},
	{
		name: "link-slash-icon",
		icon: LinkSlashIcon,
	},
	{
		name: "list-bullet-icon",
		icon: ListBulletIcon,
	},
	{
		name: "lock-closed-icon",
		icon: LockClosedIcon,
	},
	{
		name: "lock-open-icon",
		icon: LockOpenIcon,
	},
	{
		name: "magnifying-glass-circle-icon",
		icon: MagnifyingGlassCircleIcon,
	},
	{
		name: "magnifying-glass-icon",
		icon: MagnifyingGlassIcon,
	},
	{
		name: "magnifying-glass-minus-icon",
		icon: MagnifyingGlassMinusIcon,
	},
	{
		name: "magnifying-glass-plus-icon",
		icon: MagnifyingGlassPlusIcon,
	},
	{
		name: "map-icon",
		icon: MapIcon,
	},
	{
		name: "map-pin-icon",
		icon: MapPinIcon,
	},
	{
		name: "megaphone-icon",
		icon: MegaphoneIcon,
	},
	{
		name: "microphone-icon",
		icon: MicrophoneIcon,
	},
	{
		name: "minus-circle-icon",
		icon: MinusCircleIcon,
	},
	{
		name: "minus-icon",
		icon: MinusIcon,
	},
	{
		name: "minus-small-icon",
		icon: MinusSmallIcon,
	},
	{
		name: "moon-icon",
		icon: MoonIcon,
	},
	{
		name: "musical-note-icon",
		icon: MusicalNoteIcon,
	},
	{
		name: "newspaper-icon",
		icon: NewspaperIcon,
	},
	{
		name: "no-symbol-icon",
		icon: NoSymbolIcon,
	},
	{
		name: "numbered-list-icon",
		icon: NumberedListIcon,
	},
	{
		name: "paint-brush-icon",
		icon: PaintBrushIcon,
	},
	{
		name: "paper-airplane-icon",
		icon: PaperAirplaneIcon,
	},
	{
		name: "paper-clip-icon",
		icon: PaperClipIcon,
	},
	{
		name: "pause-circle-icon",
		icon: PauseCircleIcon,
	},
	{
		name: "pause-icon",
		icon: PauseIcon,
	},
	{
		name: "pencil-icon",
		icon: PencilIcon,
	},
	{
		name: "pencil-square-icon",
		icon: PencilSquareIcon,
	},
	{
		name: "percent-badge-icon",
		icon: PercentBadgeIcon,
	},
	{
		name: "phone-arrow-down-left-icon",
		icon: PhoneArrowDownLeftIcon,
	},
	{
		name: "phone-arrow-up-right-icon",
		icon: PhoneArrowUpRightIcon,
	},
	{
		name: "phone-icon",
		icon: PhoneIcon,
	},
	{
		name: "phone-xmark-icon",
		icon: PhoneXMarkIcon,
	},
	{
		name: "photo-icon",
		icon: PhotoIcon,
	},
	{
		name: "play-circle-icon",
		icon: PlayCircleIcon,
	},
	{
		name: "play-icon",
		icon: PlayIcon,
	},
	{
		name: "play-pause-icon",
		icon: PlayPauseIcon,
	},
	{
		name: "plus-circle-icon",
		icon: PlusCircleIcon,
	},
	{
		name: "plus-icon",
		icon: PlusIcon,
	},
	{
		name: "plus-small-icon",
		icon: PlusSmallIcon,
	},
	{
		name: "power-icon",
		icon: PowerIcon,
	},
	{
		name: "presentation-chart-bar-icon",
		icon: PresentationChartBarIcon,
	},
	{
		name: "presentation-chart-line-icon",
		icon: PresentationChartLineIcon,
	},
	{
		name: "printer-icon",
		icon: PrinterIcon,
	},
	{
		name: "puzzle-piece-icon",
		icon: PuzzlePieceIcon,
	},
	{
		name: "qr-code-icon",
		icon: QrCodeIcon,
	},
	{
		name: "question-mark-circle-icon",
		icon: QuestionMarkCircleIcon,
	},
	{
		name: "queue-list-icon",
		icon: QueueListIcon,
	},
	{
		name: "radio-icon",
		icon: RadioIcon,
	},
	{
		name: "receipt-percent-icon",
		icon: ReceiptPercentIcon,
	},
	{
		name: "receipt-refund-icon",
		icon: ReceiptRefundIcon,
	},
	{
		name: "rectangle-group-icon",
		icon: RectangleGroupIcon,
	},
	{
		name: "rectangle-stack-icon",
		icon: RectangleStackIcon,
	},
	{
		name: "rocket-launch-icon",
		icon: RocketLaunchIcon,
	},
	{
		name: "rss-icon",
		icon: RssIcon,
	},
	{
		name: "scale-icon",
		icon: ScaleIcon,
	},
	{
		name: "scissors-icon",
		icon: ScissorsIcon,
	},
	{
		name: "server-icon",
		icon: ServerIcon,
	},
	{
		name: "server-stack-icon",
		icon: ServerStackIcon,
	},
	{
		name: "share-icon",
		icon: ShareIcon,
	},
	{
		name: "shield-check-icon",
		icon: ShieldCheckIcon,
	},
	{
		name: "shield-exclamation-icon",
		icon: ShieldExclamationIcon,
	},
	{
		name: "shopping-bag-icon",
		icon: ShoppingBagIcon,
	},
	{
		name: "shopping-cart-icon",
		icon: ShoppingCartIcon,
	},
	{
		name: "signal-icon",
		icon: SignalIcon,
	},
	{
		name: "signal-slash-icon",
		icon: SignalSlashIcon,
	},
	{
		name: "slash-icon",
		icon: SlashIcon,
	},
	{
		name: "sparkles-icon",
		icon: SparklesIcon,
	},
	{
		name: "speaker-wave-icon",
		icon: SpeakerWaveIcon,
	},
	{
		name: "speaker-xmark-icon",
		icon: SpeakerXMarkIcon,
	},
	{
		name: "square-2-stack-icon",
		icon: Square2StackIcon,
	},
	{
		name: "square-3-stack-3d-icon",
		icon: Square3Stack3DIcon,
	},
	{
		name: "squares-2x2-icon",
		icon: Squares2X2Icon,
	},
	{
		name: "squares-plus-icon",
		icon: SquaresPlusIcon,
	},
	{
		name: "star-icon",
		icon: StarIcon,
	},
	{
		name: "stop-circle-icon",
		icon: StopCircleIcon,
	},
	{
		name: "stop-icon",
		icon: StopIcon,
	},
	{
		name: "strikethrough-icon",
		icon: StrikethroughIcon,
	},
	{
		name: "sun-icon",
		icon: SunIcon,
	},
	{
		name: "swatch-icon",
		icon: SwatchIcon,
	},
	{
		name: "table-cells-icon",
		icon: TableCellsIcon,
	},
	{
		name: "tag-icon",
		icon: TagIcon,
	},
	{
		name: "ticket-icon",
		icon: TicketIcon,
	},
	{
		name: "trash-icon",
		icon: TrashIcon,
	},
	{
		name: "trophy-icon",
		icon: TrophyIcon,
	},
	{
		name: "truck-icon",
		icon: TruckIcon,
	},
	{
		name: "tv-icon",
		icon: TvIcon,
	},
	{
		name: "underline-icon",
		icon: UnderlineIcon,
	},
	{
		name: "user-circle-icon",
		icon: UserCircleIcon,
	},
	{
		name: "user-group-icon",
		icon: UserGroupIcon,
	},
	{
		name: "user-icon",
		icon: UserIcon,
	},
	{
		name: "user-minus-icon",
		icon: UserMinusIcon,
	},
	{
		name: "user-plus-icon",
		icon: UserPlusIcon,
	},
	{
		name: "users-icon",
		icon: UsersIcon,
	},
	{
		name: "variable-icon",
		icon: VariableIcon,
	},
	{
		name: "video-camera-icon",
		icon: VideoCameraIcon,
	},
	{
		name: "video-camera-slash-icon",
		icon: VideoCameraSlashIcon,
	},
	{
		name: "view-columns-icon",
		icon: ViewColumnsIcon,
	},
	{
		name: "viewfinder-circle-icon",
		icon: ViewfinderCircleIcon,
	},
	{
		name: "wallet-icon",
		icon: WalletIcon,
	},
	{
		name: "wifi-icon",
		icon: WifiIcon,
	},
	{
		name: "window-icon",
		icon: WindowIcon,
	},
	{
		name: "wrench-icon",
		icon: WrenchIcon,
	},
	{
		name: "wrench-screwdriver-icon",
		icon: WrenchScrewdriverIcon,
	},
	{
		name: "xcircle-icon",
		icon: XCircleIcon,
	},
	{
		name: "xmark-icon",
		icon: XMarkIcon,
	},
];

export default iconsListOutline;
